import { DatePipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Message, SelectItem } from "primeng/components/common/api";
import { AppConstants } from "../core/app.constants";
import { AuthAccessProvider } from "../core/core.auth";
import { AnomalyType, BaseComponent, NewUser, Scrivania, User, UserContext, UserInfo } from "../core/core.component";
import { AnomalieService } from "../service/anomalie.service";
import { BusyProvider } from "../service/busy.service";
import { CheckhrService } from "../service/checkhr.service";
import { MessageProvider } from "../service/message.service";
import { UserService } from "../service/user.service";
import { UserCalendarService } from "../service/userCalendar.service";
import { UserOptionsService } from "../service/userOptions.service";
import { DeskManagementService } from "../service/manageDesk.service";
import { DocumentService } from "app/service/document.service";
import { GestioneUfficioService } from "../service/gestione-ufficio.service";
import { GestioneGruppiService } from "../service/gestione-gruppi.service";

declare var $: any;

@Component({
	selector: "app-users",
	templateUrl: "./users.component.html",
	styleUrls: ["./users.component.css"],
	host: { "(window:keydown)": "shortcutHandler($event)" },
})
export class UsersComponent extends BaseComponent implements OnInit {
	@Input() enableShortcut: boolean = false;

	userContext: UserContext;
	userInfo: UserInfo = new UserInfo();
	it: any = AppConstants.ITA_CALENDAR_CONF;
	users: User[] = [];
	filteredUsers: User[] = [];
	onlyActive: boolean = true;
	loading: boolean = false;
	filterQuery: string = "";
	userSelected: User = new User();
	anomalyTypes: AnomalyType[] = [];
	userFound: boolean = false;
	validationMessage: string = null;

	userName: string = null;
	userDescription: string = null;
	userStartDate: Date = new Date();
	userEndDate: Date = null;
	userTokenTBG: string = null;
	userDeviceId: string = null;
	userBlockLevel: number = null;
	userDisplayLevel: number = null;
	userIpAllowed: string = null;
	userCodiceFiscale: string = null;
	userTypeAdmin: boolean = false;
	userNotes: string = null;
	userDesk: Scrivania[] = null;
	insertDocumentErrorMessage: string[] = [];

	//user ldap
	showLdap: boolean = false;
	nome: string = null;
	cognome: string = null;
	gruppi: { label: string }[] = [];
	uffici: string[] = [];
	selectedGruppi: string[] = null;
	selectedUffici: string[] = null;
	showLogin: boolean = false;
	showLogin2: boolean = false;
	loginUsername: string = null;
	password: string = null;
	selectedUfficio: string = null;

	filesToUpload: File[] = [];
	showLoadDocumentsDialog: boolean = false;
	uploadLoading: boolean = false;
	awaitingInsertWithLdap: boolean = false;

	msgs: Message[] = [];
	uploadLocation: string = null;
	uploadLocationOptions: SelectItem[] = [{ label: "Cartella personale Utente", value: "P" }, { label: "Cartella Amministrativa", value: "A" }]

	constructor(
		protected authAccess: AuthAccessProvider,
		protected router: Router,
		protected messageProvider: MessageProvider,
		private userService: UserService,
		private anomalyService: AnomalieService,
		private busyProvider: BusyProvider,
		private datePipe: DatePipe,
		private userCalendarService: UserCalendarService,
		private checkhrService: CheckhrService,
		private userOptionsService: UserOptionsService,
		private deskManagementService: DeskManagementService,
		private documentService: DocumentService,
		private gestioneUfficioService: GestioneUfficioService,
		private gestioneGruppiService: GestioneGruppiService
	) {
		super(authAccess, router, messageProvider);
		this.messageProvider.clearAll();
	}

	ngOnInit() {
		this.userContext = this.authAccess.getUserContext();
		if (this.userContext == null) {
			this.authAccess.invalidate();
		} else {
			this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
				(result) => {
					this.userInfo = result;
					this.loadAnomalyTypes();
					this.loadUsers();
					this.loadGruppiLDAP();
				},
				(error) => {
					this.handleError(error);
				}
			);
			this.deskManagementService.getDeskManagementOperationObserver().subscribe(
				() => {
					if (this.userSelected) {
						this.deskManagementService.getUserDesk(this.userContext.srmToken, this.userSelected.id).subscribe(
							(result) => {
								this.userDesk = result.listScrivanie;

							},
							(error) => {
								this.handleError(error);
							}
						);
					}
				},
				(error) => {
					this.handleError(error);
				}
			);
		}
	}

	loadUsers() {
		this.users = [];
		this.loading = true;
		this.userService.getUsers(this.userContext.srmToken, this.onlyActive, true).subscribe(
			(result) => {
				this.users = result.users.filter((user) => this.userInfo.admin || this.userInfo.managedUsers.includes(user.username.toLowerCase()));
				this.loading = false;
				if (this.userSelected != null && this.userSelected.id > 0) {
					this.selectUser(this.userSelected);
				}
				this.filterUsers();
			},
			(error) => {
				this.handleError(error);
				this.loading = false;
			}
		);
	}

	loadAnomalyTypes() {
		this.anomalyTypes = [];
		this.anomalyService.getAnomalyTypes(this.userContext.srmToken).subscribe(
			(result) => {
				result.anomalyTypes.sort((a, b) => {
					if (a.priority == b.priority) return 0;
					return a.priority > b.priority ? 1 : -1;
				});
				this.anomalyTypes = result.anomalyTypes;
			},
			(error) => {
				this.handleError(error);
			}
		);
	}

	loadGruppiLDAP() {
		this.gruppi = [];
		this.selectedGruppi = [];
		this.userService.getGruppiLDAP(this.userContext.srmToken).subscribe(
			(result) => {
				this.gruppi = result.gruppi
					.sort((a, b) => a.nome.localeCompare(b.nome))
					.map(g => ({ label: g.nome, value: g.nome }));

				this.selectedGruppi = result.gruppi.filter(g => g.isDefault).map(g => g.nome);
				this.uffici = result.uffici;
			},

			(error) => {
				this.handleError(error);
			}
		);
	}


	storeUser() {
		this.messageProvider.clearAll();
		this.validationMessage = null;

		if (this.userStartDate == null) {
			this.validationMessage = "Inserire la data di inizio validità";
			return;
		}

		if (this.userEndDate != null && this.userStartDate >= this.userEndDate) {
			this.validationMessage = "La data di fine validità deve essere superiore alla data di inizio";
			return;
		}

		// modifica
		if (this.userSelected.id > 0) {
			const endDateChanged = this.isEndDateChanged();
			const noCredentials = !this.loginUsername || !this.password;
			this.busyProvider.showBusyIndicator();
			let user: User = this.buildUser(this.userSelected.active);
			user.id = this.userSelected.id;
			user.loginLDAPUtente = this.loginUsername;
			user.pdw = this.password;
			this.userService.updateUser(this.userContext.srmToken, user).subscribe(
				() => {
					this.busyProvider.hideBusyIndicator();
					this.msgs = [];
					this.msgs.push({ severity: "success", summary: "OK", detail: "Modifica eseguita correttamente" });
					if (endDateChanged && noCredentials) {
						this.msgs.push({ severity: "warn", summary: "Attenzione", detail: "Data fine non aggiornata su LDAP: credenziali non fornite" });
					}
					this.userSelected = user;
					this.showLogin2 = false;
					this.loadUsers();
					this.resetLogingCred();
				},
				(error) => {
					this.busyProvider.hideBusyIndicator();
					this.handleError(error);
				}
			);
		}
		// inserimento
		else {
			if (this.userName == null || this.userName.trim() == "") {
				this.validationMessage = "Inserire lo username dell'utente";
				return;
			}
			if (!this.userFound) {
				this.showLogin = true;
			}
			else {
				if (this.userEndDate != null && !this.awaitingInsertWithLdap) {
					this.awaitingInsertWithLdap = true;
					this.showLogin2 = true;
					return;
				}
				this.awaitingInsertWithLdap = false;
				this.busyProvider.showBusyIndicator();
				let user: User = this.buildUser(true);
				user.loginLDAPUtente = this.loginUsername;
				user.pdw = this.password;
				const noCredentials = !this.loginUsername || !this.password;
				this.userService.insertUser(this.userContext.srmToken, user).subscribe(
					(result) => {
						this.busyProvider.hideBusyIndicator();
						this.msgs = [];
						this.msgs.push({ severity: "success", summary: "OK", detail: "Utente inserito correttamente" });
						if (this.userEndDate != null && noCredentials) {
							this.msgs.push({ severity: "warn", summary: "Attenzione", detail: "Data fine non aggiornata su LDAP: credenziali non fornite" });
						}
						user.id = Number(result.message);
						this.userSelected = user;
						this.showLogin2 = false;
						this.loadUsers();
						this.resetLogingCred();
					},
					(error) => {
						this.busyProvider.hideBusyIndicator();
						this.handleError(error);
					}
				);
			}
		}
	}
	showLogin2Dialog() {
		if (this.isEndDateChanged()) {
			this.showLogin2 = true;
		} else {
			this.storeUser();
		}
	}

	private isEndDateChanged(): boolean {
		const original = this.userSelected.endDate ? this.datePipe.transform(this.userSelected.endDate, 'yyyy-MM-dd') : null;
		const updated = this.userEndDate ? this.datePipe.transform(this.userEndDate, 'yyyy-MM-dd') : null;
		return original !== updated;
	}

	skipLdapAndSave() {
		this.loginUsername = null;
		this.password = null;
		this.showLogin2 = false;
		this.storeUser();
	}

	insertNewUser() {
		this.busyProvider.showBusyIndicator();
		let user: NewUser = this.buildNewUser(true);
		this.userService.insertNewUser(this.userContext.srmToken, user).subscribe(
			(result) => {
				this.busyProvider.hideBusyIndicator();
				this.msgs = [];
				this.msgs.push({ severity: "success", summary: "OK", detail: "Utente inserito correttamente" });
				user.id = Number(result.message);
				this.userSelected = user;
				this.showLogin = false;
				this.loadUsers();
				this.resetLogingCred();
			},
			(error) => {
				this.busyProvider.hideBusyIndicator();
				this.handleError(error);
				this.showLogin = false;
				this.resetLogingCred();
			}
		);
	}
	resetLogingCred() {
		this.loginUsername = null;
		this.password = null;
	}
	closeLogin() {
		this.showLogin = false;
	}
	closeLogin2() {
		this.showLogin2 = false;
		this.awaitingInsertWithLdap = false;
		this.resetLogingCred();
	}

	buildUser(active): User {
		let user: User = new User();
		user.username = this.userName;
		if (this.userSelected.id > 0) {
			user.username = this.userSelected.username;
		}
		user.startDate = this.userStartDate;
		user.endDate = this.userEndDate;
		user.tokenTBG = this.userTokenTBG;
		user.deviceId = this.userDeviceId;
		user.blockingLevel = this.userBlockLevel ? this.userBlockLevel : -1;
		user.displayLevel = this.userDisplayLevel ? this.userDisplayLevel : -1;
		user.codiceFiscale = this.userCodiceFiscale;
		user.ipAllowed = this.userIpAllowed;
		user.typeUser = this.userTypeAdmin ? "A" : "U";
		user.active = active;
		user.notes = this.userNotes;
		return user;
	}

	buildNewUser(active): NewUser {
		let user: NewUser = new NewUser();
		user.username = this.userName;
		if (this.userSelected.id > 0) {
			user.username = this.userSelected.username;
		}
		user.startDate = this.userStartDate;
		user.endDate = this.userEndDate;
		user.deviceId = this.userDeviceId;
		user.codiceFiscale = this.userCodiceFiscale;
		user.ipAllowed = this.userIpAllowed;
		user.typeUser = this.userTypeAdmin ? "A" : "U";
		user.active = active;
		user.notes = this.userNotes;
		user.nome = this.nome;
		user.cognome = this.cognome;
		user.gruppi = this.selectedGruppi;
		user.loginLDAPUtente = this.loginUsername;
		user.pdw = this.password;
		return user;
	}

	checkDomainUser() {
		this.messageProvider.clearAll();
		this.userDescription = null;
		this.validationMessage = null;
		this.userFound = false;
		if (this.userName == null || this.userName.trim() == "") {
			return;
		}
		this.userService.findDomainUser(this.userContext.srmToken, this.userName).subscribe(
			(result) => {
				this.userDescription = result.message;
				this.userFound = true;
				this.showLdap = false;
			},
			(error) => {
				let err = JSON.parse(JSON.stringify(error.json()));
				if (err.status == 404) {
					this.userDescription = "Utente non censito su LDAP";
					this.userFound = false;
					this.showLdap = true;
				} else {
					this.userName = null;
					this.handleError(error);
				}
			}
		);
	}

	selectUser(user: User) {
		this.validationMessage = null;
		this.userSelected = user;
		this.userStartDate = AppConstants.parseDate(this.datePipe.transform(user.startDate, "dd/MM/yyyy"));
		this.userEndDate = AppConstants.parseDate(this.datePipe.transform(user.endDate, "dd/MM/yyyy"));
		this.userTokenTBG = user.tokenTBG;
		this.userDeviceId = user.deviceId;
		this.userIpAllowed = user.ipAllowed;
		this.userCodiceFiscale = user.codiceFiscale;
		this.userTypeAdmin = user.typeUser == "A";
		this.userBlockLevel = user.blockingLevel;
		this.userDisplayLevel = user.displayLevel;
		this.userNotes = user.notes;
		this.selectedUffici = user.ufficio;


		this.deskManagementService.getUserDesk(this.userContext.srmToken, user.id).subscribe(
			(result) => {
				this.userDesk = result.listScrivanie;
			},
			(error) => {
				this.handleError(error);
			}
		);
	}

	openExtraWorkDialog(user: User) {
		if (user != null) {
			this.userCalendarService.openUserExtraWorkComponent(user);
		}
	}

	openCheckhrUserDialog(user: User) {
		if (user != null) {
			this.checkhrService.openCheckhrUserComponent(user);
		}
	}

	openUserDataDialog(user: User) {
		if (user != null) {
			this.userService.openUserDataComponent(user);
		}
	}

	openUserCalendarDialog(user: User) {
		if (user != null) {
			this.userCalendarService.openUserCalendarComponent(user);
		}
	}

	openUserOptionsDialog(user: User) {
		if (user != null) {
			this.userOptionsService.openUserOptionsComponent(user);
		}
	}

	openManageDeskDialog(user: User) {
		if (user != null) {
			this.deskManagementService.openManageDeskComponent(user, this.userDesk);
		}
	}
	openAnomalieDialog(user: User) {
		if (user != null) {
			this.anomalyService.openAnomalieComponent(user);
		}
	}
	openGestioneUffcioDialog(user: User) {
		if (user != null) {
			user.uffici = this.uffici
			this.gestioneUfficioService.openGestioneUfficioComponent(user);

		}
	}

	openGestioneGruppiDialog(user: User) {
		if (user != null) {
			this.gestioneGruppiService.openGestioneGruppiComponent(user);

		}
	}
	riceviMessaggio(user: User) {
		this.msgs.push({
			severity: "success", summary: "OK", detail: "Modifica dell'ufficio effettuata"
		});
		this.loadUsers();
		this.selectUser(user);
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}

	addNewUser() {
		this.validationMessage = null;
		this.messageProvider.clearAll();
		this.userSelected = new User();
		this.userName = null;
		this.userDescription = null;
		this.userStartDate = new Date();
		this.userEndDate = null;
		this.userTokenTBG = null;
		this.userDeviceId = null;
		this.userBlockLevel = null;
		this.userDisplayLevel = null;
		this.userIpAllowed = null;
		this.userCodiceFiscale = null;
		this.userTypeAdmin = false;
		this.selectedUfficio = null;
		this.userFound = false;
		this.showLdap = false;
		this.nome = null;
		this.cognome = null;
		this.awaitingInsertWithLdap = false;
	}

	filterUsers() {
		this.filteredUsers = this.users;
		if (this.filterQuery != null && this.filterQuery.trim() != "") {
			this.filteredUsers = [];
			for (let i = 0; i < this.users.length; ++i) {
				if (this.users[i].username.toLowerCase().indexOf(this.filterQuery.toLowerCase()) >= 0) {
					this.filteredUsers.push(this.users[i]);
				}
			}
		}
		if (this.filteredUsers.length == 1) {
			this.userSelected = this.filteredUsers[0];
			this.selectUser(this.userSelected);
		}
	}

	shortcutHandler(event) {
		if (this.enableShortcut == false || !this.userInfo.admin) {
			return;
		}
		// F2
		if (event.keyCode == 113) {
			if (this.userSelected.id > 0) {
				this.showLogin2Dialog();
			} else {
				this.storeUser();
			}
		}
		// CTRL + I
		if (event.ctrlKey && event.keyCode == 73) {
			this.addNewUser();
		}
	}

	openLoadDocuments() {
		$("#loadDocumentsDialog").modal({ backdrop: "static", keyboard: false });
		this.uploadLocation = null;
	}

	hideLoadDocuments() {
		this.insertDocumentErrorMessage = [];
		$("#loadDocumentsDialog").modal("hide");
		this.filesToUpload = [];
		this.uploadLocation = null;
	}

	openFileSelector() {
		$("#fileUpload").click();
	}

	addFiles(event) {
		this.insertDocumentErrorMessage = [];
		for (var i = 0; i < event.target.files.length; i++) {
			this.filesToUpload.push(event.target.files[i]);
		}
	}

	removeDocument(index: number) {
		this.insertDocumentErrorMessage = [];
		this.filesToUpload.splice(index, 1);
	}

	loadDocuments() {
		this.insertDocumentErrorMessage = [];
		if (["P", "A"].includes(this.uploadLocation)) {
			if (this.filesToUpload.length > 0) {
				let formData = new FormData();
				for (var i = 0; i < this.filesToUpload.length; i++) {
					formData.append("files", this.filesToUpload[i]);
				}
				formData.append("username", this.userSelected.username);
				formData.append("uploadLocation", this.uploadLocation)
				this.uploadLoading = true;
				this.documentService.uploadUserDocuments(this.userContext.srmToken, formData).subscribe(
					(response) => {
						this.uploadLoading = false;
						if (response.list != null && response.list.length > 0) {
							this.insertDocumentErrorMessage = response.list;
						} else {
							this.hideLoadDocuments();
						}
					},
					(error) => {
						this.uploadLoading = false;
						this.handleError(error);
					}
				);
			}
		}
		else {
			this.insertDocumentErrorMessage.push("Seleziona una cartella dove caricare il file")
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/users/users.component.ts